export const environment = {

  serviceName: 'PostcodeJP API',
  
  useMockHttpInterceptor: false,
  
  appTitle: 'PostcodeJP API',

  apiUrl: 'https://console-webapi.postcode-jp.com',

  apikeyDocumentUrl: 'https://api-doc.postcode-jp.com/',

  faqUrl: 'https://postcode-jp.com/faq',

  statusPageUrl: 'https://postcodejpapi.statuspage.io/',

  frontUrl: 'https://console.postcode-jp.com/',
  
  termsPath: 'terms/postcodejp',
  privacyPolicyPath: 'privacy/postcodejp',

};
